import api from "../../services/api";
const namespaced = true;

const state = {
  users: [],              // Lista dei clienti
  selectedUserID: null,       // ID del cliente selezionato
  structures: [],         // Lista delle strutture
  selectedStructureID: null,  // ID della struttura selezionata
  loading: false
};

const getters = {
  getUsers: (state) => state.users,
  //getSelectedUser: (state) => state.selectedUserID,
  getSelectedUser: (state) => (state.users.find((s) => s._id === state.selectedUserID) || null),
  getStructures: (state) => state.structures,
  getSelectedStructure: (state) => state.structures.find((s) => s._id === state.selectedStructureID || null),
  getLoadingStatus: (state) => state.loading
};

const actions = {
  async fetchUsers({ commit }) {
    const users = await api.getUsers();
    commit("setUsers", users);
  },
  /* Seleziona l'utente dato il suo ID */
  async selectUser({ commit }, userID) {
    //const existingUser = state.users.find((s) => s._id === userID);
    //commit("selectUser", existingUser);

    commit("selectUser", userID);
  },
  /* Esegue il fetching di tutte le strutture */
  async fetchStructures({ commit }, userID) {
    const structures = await api.getStructures(userID);
    commit("setStructures", structures);
    commit("selectStructure", null);

  },
  /* Dato l'ID di una struttra esistente, la seleziona */
  async selectStructure({ commit }, structureID) {
    //const existingStruct = state.structures.find((s) => s._id === structureID);
    //if (existingStruct) commit("selectStructure", existingStruct);
    commit("selectStructure", structureID);
  },
  async insertStructure({ /* commit,  */ dispatch }, structure) {
    let insertedStructure = await api.insertStructure(
      state.selectedUserID,
      structure
    );
    console.log(insertedStructure);
    await dispatch("fetchStructures", state.selectedUserID);
  },
  async editStructure({ dispatch }, structure) {
    const userID = state.selectedUserID;
    const structureID = structure._id;
    const structureInfo = {
      name: structure.name,
      address: structure.address,
      spans: structure.spans,
      installDate: structure.installDate,
      fddEnabled: structure.fddEnabled,
      type: structure.type,
      coordinates: {
        lat: structure.coordinates.lat,
        lng: structure.coordinates.lng,
      },
    };
    await api.editStructure(
      userID,
      structureID,
      structureInfo
    );
    let selectedStructure = state.selectedStructureID;
    await dispatch("fetchStructures", state.selectedUserID);
    await dispatch("selectStructure", selectedStructure);

  },
  async deleteStructureImage({ dispatch }, imageID) {
    await api.deleteImageFromStructure(state.selectedUserID, state.selectedStructureID, imageID);
    await dispatch("fetchStructures", state.selectedUserID);

  },
  async addStructureImage({ dispatch }, image) {
    await api.addImageToStructure(state.selectedUserID, state.selectedStructureID, image);
    await dispatch("fetchStructures", state.selectedUserID);

  },
  async deleteStructure({ dispatch }, structure) {
    await api.deleteStructure(
      state.selectedUserID,
      structure._id
    );
    await dispatch("fetchStructures", state.selectedUserID);
  },
  async deleteOldEvents({ dispatch }, structure) {
    let selectedStructure = state.selectedStructureID;
    await api.deleteOldEvents(
      state.selectedUserID,
      structure._id
    );
    await dispatch("selectStructure", selectedStructure);

  },
  async editSensorPosition({ dispatch }, newSensorPosition) {
    await api.adminSaveSensorsPosition(
      state.selectedUserID,
      { sensors: newSensorPosition }
    );
    await dispatch("fetchStructures", state.selectedUserID);
  },
  async deleteCustomer({ dispatch }, customerID) {
    await api.deleteUser(customerID);
    if (customerID === state.selectedUserID) {
      await dispatch("selectUser", state.users.find(u => u._id != customerID)._id);
    }
    await dispatch("fetchUsers");
    // Se ho eliminato l'utente selezionato, ne scelgo uno nuovo

  },
  async addCustomer({ dispatch }, customer) {
    let inserted = await api.addUser(customer);
    await dispatch("fetchUsers");
    await dispatch("selectUser", inserted._id);
    await dispatch("fetchStructures", state.selectedUserID);
  },
  async editCustomer({ dispatch }, { customerID, customerInfo }) {
    await api.editUser(customerID, customerInfo);
    await dispatch("fetchUsers");
  },
  async deleteSensor({ dispatch }, sensorEUI) {
    await api.deleteSensor(state.selectedStructureID, state.selectedUserID, sensorEUI);
    let selectedStructure = state.selectedStructureID;
    await dispatch("fetchStructures", state.selectedUserID);
    await dispatch("selectStructure", selectedStructure);
  },
  async setLoadingStatus({ commit }, status) {
    commit("setLoadingStatus", status);
  },
  async addSensor({ dispatch }, sensor) {
    await api.addSensors(state.selectedUserID, state.selectedStructureID, [sensor]);
    let selectedStructure = state.selectedStructureID;
    await dispatch("fetchStructures", state.selectedUserID);
    await dispatch("selectStructure", selectedStructure);

  },
  async updateSensor({ dispatch }, sensorObject) {
    await api.updateSensor(state.selectedUserID, sensorObject.eui, sensorObject.sensorInfo);
    let selectedStructure = state.selectedStructureID;
    await dispatch("fetchStructures", state.selectedUserID);
    await dispatch("selectStructure", selectedStructure);
  },
  async updateFDDGroups({ dispatch }, { sensorType, sensorGroups }) {
    console.log(sensorType, sensorGroups)
    await api.updateFDDGroups(state.selectedUserID, state.selectedStructureID, sensorType, { sensorGroups: sensorGroups });
    let selectedStructure = state.selectedStructureID;
    await dispatch("fetchStructures", state.selectedUserID);
    await dispatch("selectStructure", selectedStructure);
  }
};

const mutations = {
  setUsers: (state, users) => (state.users = users),
  selectUser: (state, user) => (state.selectedUserID = user),
  setStructures: (state, structures) => (state.structures = structures),
  selectStructure: (state, structure) => (state.selectedStructureID = structure),
  setLoadingStatus: (state, status) => (state.loading = status)
};

export default {
  namespaced,
  state,
  getters,
  actions,
  mutations,
};
